import axiosAuth from '../../axiosMain';

async function index(question_type_id) {
  let response = await axiosAuth.get('/dashboard_total_progress/' + question_type_id);
  return response.data;
}

export default {
  index,
};
